import { useDrag } from "react-dnd";

interface SidebarDraggableFieldProps {
  field: string;
  type: string;
  /**
   * Inline mode: when set, this signer id is stamped on the dropped
   * FieldData so the backend knows which signer owns it.
   */
  signerId?: string;
  disabled?: boolean;
}

function SidebarDraggableField({
  field,
  type,
  signerId,
  disabled,
}: SidebarDraggableFieldProps) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "FIELD",
      item: { type, name: field, signerId },
      canDrag: !disabled,
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [type, field, signerId, disabled],
  );

  return (
    <div
      ref={drag as any}
      className={`p-3 w-full text-sm flex flex-row justify-between bg-white rounded-lg border border-neutral-200 transition-all ${
        disabled
          ? "opacity-40 cursor-not-allowed"
          : "hover:shadow-md active:bg-blue-50 active:border-blue-500 active:border-dashed cursor-grab"
      }`}
      style={{ opacity: isDragging ? 0.5 : undefined }}
    >
      <span className="truncate">{field}</span>
      <div className="rounded-full p-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="gray"
          width="20"
          height="20"
        >
          <path d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z" />
        </svg>
      </div>
    </div>
  );
}

export default SidebarDraggableField;
